import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";

const FileViewer = ({
  isModelOpen,
  setIsModelOpen,
  onModelClose,
  file,
}: {
  isModelOpen: boolean;
  setIsModelOpen(isOpen: boolean): void;
  onModelClose(): void;
  file: { name: string; content: string; type: string } | undefined;
}) => {
  const downloadToBrowser = (
    file: { name: string; content: string; type: string } | undefined
  ) => {
    const downloadUrl = `data:${"application/octet-stream"};base64,${
      file?.content
    }`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = file?.name ?? "Download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  };

  return (
    <Dialog
      fullScreen={true}
      open={isModelOpen}
      onClose={onModelClose}
      aria-labelledby="responsive-dialog-title"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle id="responsive-dialog-title">
          {file?.name ?? ""}
        </DialogTitle>
        <div style={{ alignSelf: "center", marginRight: "20px" }}>
          {file?.type !== "pdf" ? (
            <IconButton
              style={{
                alignSelf: "center",
                marginRight: "20px",
              }}
              onClick={() => {
                downloadToBrowser(file);
              }}
            >
              <span title="Download" className="material-symbols-outlined">
                download
              </span>
            </IconButton>
          ) : (
            ""
          )}
          <IconButton
            style={{
              alignSelf: "center",
            }}
          >
            <span
              title="close"
              className="material-symbols-outlined"
              style={{ alignSelf: "center", cursor: "pointer" }}
              onClick={() => {
                setIsModelOpen(false);
              }}
            >
              close
            </span>
          </IconButton>
        </div>
      </div>

      <DialogContent>
        {file?.content?.length ? (
          <object
            aria-label="data"
            data={
              (file.type === "pdf"
                ? "data:application/pdf;base64,"
                : "data:image/png;base64,") + file.content
            }
            width="100%"
            height="99%"
          />
        ) : (
          <Alert severity="error">
            Error Occurred, while loading the document!!!
          </Alert>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FileViewer;
